<div class="row d-flex justify-content-between">
    <div class="col">
        <button class="btn btn-sm blue-btn" data-bs-toggle="modal" data-bs-target="#DocumentModal" (click)="reset()"  [disabled]="global.viewTabs">Add Document</button>
    </div>
    <div class="col text-end">
        <button class=" btn btn-sm blue-btn" (click)="Refresh()"  [disabled]="global.viewTabs" >Refresh</button>
    </div>
</div>
<div class="row mb-2">
    <div class="col mt-1">
        <ejs-grid #grid [dataSource]='DocumentList | async' [allowResizing]='true' allowPaging='true'
            [allowSorting]='true' [allowPaging]='true' [filterSettings]='filterOptions'
            (dataStateChange)='dataStateChange($event)' (actionBegin)="onActionComplete($event)" [allowFiltering]='true'
            [showColumnChooser]="true">
            <e-columns>
                <e-column [showInColumnChooser]='false' uid="action" headerText="Actions" width=100>
                    <ng-template #template let-data>
                        <button class="btn btn-sm me-2 ms-1" (click)="DownloadDocument(data)"  [disabled]="global.viewTabs">
                            <i class="fa fa-download"></i>
                        </button>
                        <button *ngIf="validateContentType(data)" class="btn btn-sm me-2" ejs-button (click)="GetDocumentBase64(data)" [disabled]="global.viewTabs">
                            <i class="fa fa-eye"></i></button>
                        <button class="btn btn-sm btn-delete-table me-1" (click)="setDocumentId(data)"
                            data-bs-toggle="modal" data-bs-target="#modalDeleteClientDocument"  [disabled]="global.viewTabs">
                            <i class="fa fa-trash"></i>
                        </button>
                    </ng-template>
                </e-column>
                <e-column minWidth=150 field="documentTitle" headerText="DocumentTitle" type='string'>
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value">
                        </ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=150 field="documentName" headerText="DocumentName" type='string'>
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value">
                        </ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=150 field="attachedDate" headerText="AttachedDate" type='datetime'
                [format]="formatOptions" [allowFiltering]="false" [allowSorting]="false" allowEditing="false">
                </e-column>
                <e-column minWidth=150 field="fileExtension" headerText="Content Type" type='string'>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>
</div>

<!-- Documnet Form Modal-->
<span id="DocumentModalopen" data-bs-toggle="modal" data-bs-target="#DocumentModal"></span>
<div class="modal fade" id="DocumentModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="DocumentModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" id="smallModal">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="DocumentModalLabel"> Client Document </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="d-flex">
                    <div class="col-12" id="fisrtcol">
                        <div class="row mt-2">
                            <div class="col-lg-4">
                                <label>Document Title<sup class="super-script">*</sup></label>
                            </div>
                            <div class="col-lg-7">
                                <input class="form-control" [(ngModel)]="ClientDocumentForm.documentTitle">
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-lg-4">
                                <label>Document<sup class="super-script">*</sup></label>
                            </div>
                            <div class="col-lg-5">
                                <input type="file" (change)="onFileChange($event)" id="ClientDocumentFormFile" class="form-control">
                                <label style="color:#004290">{{ClientDocumentForm.documentName}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" (click)="saveDocument()" class="btn btn-sm"
                    [disabled]="(ClientDocumentForm.documentTitle == null || ClientDocumentForm.documentTitle == undefined || ClientDocumentForm.fileAt == null || ClientDocumentForm.fileAt == undefined || ClientDocumentForm.documentTitle == '')">
                    save </button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<span id="openClientDocument" data-bs-toggle="modal" data-bs-target="#modalDeleteClientDocument"></span>
<div class="modal fade modalbackgrod" id="modalDeleteClientDocument" tabindex="-1"
    aria-labelledby="modalClientDocumentLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Delete </span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>
            <div class="modal-body">
                Are you sure you want to Delete?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="Delete()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>
<span id="openViewDocumentModel" data-bs-toggle="modal" data-bs-target="#ViewDocumentModel"></span>
<div class="modal fade" id="ViewDocumentModel" aria-labelledby="documentViewModalLabel"
    aria-hidden="true" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header mb-1">
                <h5 class="modal-title" id="documentViewModalLabel">{{ this.DocumentName }}</h5>
                <button type="button" class="blue-btn btn-sm text-white" data-bs-dismiss="modal" aria-label="Close">
                    Close
                </button>
            </div>
            <div *ngIf="isPdf" class="modal-body" id="client-docs-pdf-body">
                <ngx-extended-pdf-viewer
                    id="client-docs-pdf-element"
                    [src]="this.DocumentUrl"
                    [useBrowserLocale]="true"
                    crossorigin="anonymous"
                    [showToolbar]="true"
                    [zoom]="'100'">
                </ngx-extended-pdf-viewer>
            </div>
            <div *ngIf="!isPdf" class="modal-body" id="client-docs-image-body">
                <img id="outputImage" class="img-fluid" alt="Rendered Image" [src]="this.DocumentUrl" />
            </div>
        </div>
    </div>    
</div>